function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FocusEventHandler, MouseEventHandler, ComponentType, ComponentClass, MouseEvent, FocusEvent, PureComponent, Ref } from 'react';
import { getDisplayName } from '../../lib/getDisplayName';
export function withControl(WrappedComponent) {
  class WithControl extends PureComponent {
    static displayName = `WithControl(${getDisplayName(WrappedComponent)})`;
    state = {
      focused: this.props.focused,
      pressed: this.props.pressed,
      disabled: this.props.disabled
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.disabled !== nextProps.disabled) {
        this.setState({
          disabled: nextProps.disabled
        });
      }
      if (this.props.focused !== nextProps.focused) {
        this.setState({
          focused: nextProps.focused
        });
      }
      if (this.props.pressed !== nextProps.pressed) {
        this.setState({
          pressed: nextProps.pressed
        });
      }
      if (nextProps.disabled) {
        this.setState({
          focused: false,
          pressed: false
        });
      }
    }
    render() {
      const {
        disabled,
        focused,
        pressed
      } = this.state;
      // Оборачиваемый компонент явно может не реализовывать интерфейс для передаваемых свойств,
      // но все компоненты обязаны поддержать передачу всех свойств на DOM узел, поэтому тут мы
      // приводим тип оборачиваемого компонента к нужному виду.
      const Component = WrappedComponent;
      return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
        focused: !disabled ? focused : undefined,
        pressed: !disabled ? pressed : undefined,
        onMouseDown: !disabled ? this.onMouseDown : undefined,
        onMouseUp: !disabled ? this.onMouseUp : undefined,
        onFocus: !disabled ? this.onFocus : undefined,
        onBlur: !disabled ? this.onBlur : undefined
      }));
    }
    onMouseDown = event => {
      // по нажатию правой кнопки мыши
      // не нужно выставлять pressed
      if (event.nativeEvent.which === 3) {
        return;
      }
      this.setState({
        pressed: true
      });
      this.docOnMouseDown();
      if (this.props.onMouseDown !== undefined) {
        this.props.onMouseDown(event);
      }
    };
    onMouseUp = event => {
      this.setState({
        pressed: false
      });
      if (this.props.onMouseUp !== undefined) {
        this.props.onMouseUp(event);
      }
    };
    docOnMouseDown = () => {
      if (typeof window === 'undefined') {
        return;
      }
      // необходимо слушать mouseup вне блока, иначе
      // при отпущенной вовне кнопке мыши блок остается pressed
      document.addEventListener('mouseup', this.docOnMouseUp);
      // необходимо для button2_type_link
      document.addEventListener('dragend', this.docOnMouseUp);
    };
    docOnMouseUp = () => {
      if (typeof window === 'undefined') {
        return;
      }
      this.setState({
        pressed: false
      });
      document.removeEventListener('mouseup', this.docOnMouseUp);
      document.removeEventListener('dragend', this.docOnMouseUp);
    };
    onFocus = event => {
      this.setState({
        focused: true
      });
      if (this.props.onFocus !== undefined) {
        this.props.onFocus(event);
      }
    };
    onBlur = event => {
      this.setState({
        focused: false
      });
      if (this.props.onBlur !== undefined) {
        this.props.onBlur(event);
      }
    };
  }
  return WithControl;
}